import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Optional copy — a hint, a blurb, an impact line — resolved only when the key
 * actually exists. `t(key, { defaultValue: '' })` would work too, but it logs a
 * missingKey warning for every field that legitimately has no impact line,
 * which buries real missing-copy warnings in noise.
 *
 * Its own module because both `SettingsPage` and the extracted `FieldRow` call
 * it, and neither should have to import the other to get it.
 */
export function useOptionalCopy(): (key: string) => string {
  const { t, i18n } = useTranslation();
  return useCallback(
    (key: string) => (i18n.exists(key) ? t(key) : ''),
    [i18n, t]
  );
}
